import { NavLink } from 'react-router-dom';

export default function SidebarLink({ to, label, onClick}) {
    return (
        <NavLink to={to} onClick={onClick} className={({ isActive }) => `group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition ${isActive ? 'bg-docpgrPurple10 text-docpgrPurple' : 'text-sltae-500 hover:bg-slate-100 hover:text-slate-800 '}`}>
            <span>{label}</span>
        </NavLink>
    )
};